<template>
    <!-- Delivery instructions textarea field -->
    <div :class="deliveryInstructionsInputClass">
        <p class="mb-1 mt-8 text-left" v-html="label || $t('DELIVERY_DAY_FIELD_WHERE_SHALL_WE')"/>
        <textarea
            rows="4"
            id="delivery-instructions"
            name="delivery-instructions"
            class="input__textarea"
            v-model="deliveryInstructions"
            :placeholder="$t('DELIVERY_INSTRUCTIONS_FIELD_PLEASE_POP')"
            maxlength="50"/>

        <!-- Validation -->
        <p class="input__message"
           v-if="showRequiredValidationMessage"
           v-text="$t('DELIVERY_INSTRUCTIONS_FIELD_SOMETIMES')"/>
    </div>
</template>

<script>
import requiredIf from 'vuelidate/src/validators/requiredIf';

export default {
    name: 'DeliveryInstructionsField',
    props: {
        require: {
            default: false,
            type: Boolean,
        },
        value: {
            default: null,
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
    },
    data() {
        return {
            deliveryInstructions: null,
        };
    },
    mounted() {
        this.deliveryInstructions = this.value;
    },
    computed: {
        deliveryInstructionsInputClass() {
            if (this.deliveryInstructions === null) return 'input';

            return this.isDeliveryInstructionsValid ? 'input input--success' : 'input input--invalid';
        },

        isDeliveryInstructionsValid() {
            return !this.$v.$invalid;
        },

        isRequired() {
            return this.require;
        },

        showRequiredValidationMessage() {
            return this.deliveryInstructions !== null && !this.$v.deliveryInstructions.required;
        },
    },
    methods: {
        /**
         * Sync with parent component.
         *
         * @returns {void}
         */
        updateInput() {
            this.$v.$touch();

            this.$emit('input', this.deliveryInstructions);
        },
    },
    validations: {
        deliveryInstructions: {
            required: requiredIf('isRequired'),
        },
    },
    watch: {
        deliveryInstructions() {
            this.updateInput();
        },
        value(newValue) {
            if (newValue !== this.deliveryInstructions) {
                this.deliveryInstructions = newValue;
            }
        },
    },
};
</script>
